import React, { createContext, useContext, useState } from 'react'

// create a context
const themeContext = createContext(true);  // true -> light, false -> dark

// custom hook to use the theme context
export const useTheme = () => {
    const theme = useContext(themeContext)
    return theme
}

const ThemeContext = ({children}) => {
    const [theme, setTheme] = useState(true)
    const toggleTheme = () => {
        setTheme(!theme)
    }
  return (
    <themeContext.Provider value={{theme, toggleTheme}}>
        {children}
    </themeContext.Provider>
  )
}

export default ThemeContext